import React from 'react'
import SheetBridgeIcon from 'components/AppDetail/Data/Panel/Items/SheetBridgeIcon'

export const SheetBridgeLogo = () => (
  <div className="sheetbridge-modal-header">
    <div className="sheetbridge-logo-header">
      <span className="sheet-text">Sheet</span>
      <SheetBridgeIcon className="bridge-icon" variant="teal" />
      <span className="bridge-text">Bridge</span>
    </div>
    <p className="sheetbridge-modal-subtitle">
      Connect your Google Sheets as external collections
    </p>
  </div>
)
